// MOCK DATA — seeded from Serpens content. Replaced by backend API in full-stack phase.
export const MOCK_PORTFOLIO = [
  {
    "title": "Enterprise Software Partnership",
    "industry": "Enterprise",
    "type": "Custom Software & Maintenance",
    "description": "Custom software that became a core company asset, backed by top-notch maintenance and rapid-response support.",
    "outcomes": [
      "Top-notch maintenance services",
      "Rapid-response support"
    ],
    "tech": [
      "Python",
      "PostgreSQL"
    ],
    "image": null,
    "live_url": null,
    "id": "78f3fcb2-a0ae-4c6e-a76a-c44eb839d3a0",
    "created_at": "2026-08-06T07:47:29.680263+00:00"
  },
  {
    "title": "DBS QA Technologies",
    "industry": "Technology",
    "type": "Corporate Website & Support",
    "description": "A corporate website backed by always-available, customer-service-first support for the DBS QA team.",
    "outcomes": [
      "Always-available support",
      "Client recommends without hesitation"
    ],
    "tech": [
      "React",
      "PHP"
    ],
    "image": "https://images.unsplash.com/photo-1629904853716-f0bc54eea481?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwdGVhbSUyMHByb2dyYW1taW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NTk5NzcxOHww&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "live_url": null,
    "id": "bb99156a-bf79-4318-a7bd-e04e7f6d8c86",
    "created_at": "2026-08-06T07:47:29.255873+00:00"
  },
  {
    "title": "ComplyIT365",
    "industry": "Professional Services",
    "type": "Business Websites & Digital Setup",
    "description": "Web presence and digital setup for multiple businesses under the ComplyIT365 umbrella — each one delivered exactly to expectation.",
    "outcomes": [
      "Multiple businesses launched",
      "Responsive long-term partnership"
    ],
    "tech": [
      "WordPress",
      "React"
    ],
    "image": "https://images.unsplash.com/photo-1655841439659-0afc60676b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdsYXNzbW9ycGhpc20lMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3ODU5OTc3MTh8MA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "live_url": null,
    "id": "8da9699b-fe82-4beb-beae-c8f7210111ea",
    "created_at": "2026-08-06T07:47:28.755779+00:00"
  },
  {
    "title": "Gokul Driving School",
    "industry": "Education",
    "type": "Business Website",
    "description": "A professional website for a Bengaluru driving school — delivered on time with dependable post-launch support.",
    "outcomes": [
      "On-time project delivery",
      "Reliable ongoing support"
    ],
    "tech": [
      "React",
      "Node.js"
    ],
    "image": "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdsYXNzbW9ycGhpc20lMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3ODU5OTc3MTh8MA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "live_url": null,
    "id": "1542644c-481d-4d8e-ae61-89d4b51bf8ad",
    "created_at": "2026-08-06T07:47:28.456285+00:00"
  },
  {
    "title": "Multi Axis E-Learning",
    "industry": "Education",
    "type": "E-Learning Platform",
    "description": "An e-learning website built on the latest technologies and trends — delivered end to end, from initial consultation to final launch.",
    "outcomes": [
      "Exceptional launch experience",
      "Modern e-learning technology stack"
    ],
    "tech": [
      "Next.js",
      "Laravel",
      "MySQL"
    ],
    "image": "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxkYXRhJTIwYW5hbHl0aWNzJTIwY2hhcnR8ZW58MHx8fHwxNzg1OTk3NzIzfDA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "live_url": null,
    "id": "32e6a270-847c-43a9-997a-1a4da68493e4",
    "created_at": "2026-08-06T07:47:28.066677+00:00"
  },
  {
    "title": "Moderntechpitstop Store",
    "industry": "E-commerce",
    "type": "E-commerce Website",
    "description": "A custom eCommerce website that took Moderntechpitstop's business online — storefront, product catalog, and a smooth buying experience built for growth.",
    "outcomes": [
      "Business taken fully online",
      "Growth cycle kick-started after launch"
    ],
    "tech": [
      "React",
      "Node.js",
      "MongoDB"
    ],
    "image": "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzJTIwY2hhcnR8ZW58MHx8fHwxNzg1OTk3NzIzfDA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "live_url": null,
    "id": "8c374a2d-44b3-48b4-8ce7-aaf81d09262b",
    "created_at": "2026-08-06T07:47:27.855851+00:00"
  }
];

export const MOCK_BLOG = [
  {
    "slug": "why-custom-software-beats-off-the-shelf",
    "title": "Why Custom Software Beats Off-the-Shelf Tools for Growing Businesses",
    "excerpt": "Off-the-shelf tools force your business into someone else's workflow. Here is how custom software compounds efficiency, cuts long-term costs, and becomes a competitive moat.",
    "category": "Software Development",
    "author": "Arjun Mehta",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzJTIwY2hhcnR8ZW58MHx8fHwxNzg1OTk3NzIzfDA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-06-18T09:00:00+00:00",
    "content": "Every growing business eventually hits the same wall: the SaaS tools that once felt like a bargain now dictate how your team works. You pay per seat, per month, forever — and you still export data to spreadsheets to fill the gaps.\n\nCustom software flips that equation. Instead of adapting your process to a vendor's roadmap, the system is engineered around the way your business actually operates. Approval chains, pricing rules, inventory logic, compliance checks — all encoded exactly once, then executed flawlessly a thousand times a day.\n\nThe economics are compelling too. Our clients typically recover the build cost within 12 to 18 months through license savings alone, before counting the hours returned to their teams. One manufacturing client replaced four disconnected tools with a single ERP we built, and cut order-processing time by 62%.\n\nMost importantly, custom software is an asset you own. It appreciates as you extend it — new modules, AI copilots, customer portals — while subscriptions only ever depreciate your margins. If your operations are your advantage, your software should be too.",
    "id": "36b23d98-9e13-45c9-996e-fb7640ca81d5"
  },
  {
    "slug": "ai-agents-in-enterprise-workflows",
    "title": "AI Agents in Enterprise Workflows: Beyond the Chatbot Hype",
    "excerpt": "Chatbots answer questions. AI agents do the work. A practical look at how retrieval-augmented generation and autonomous agents are reshaping support, operations, and sales.",
    "category": "Artificial Intelligence",
    "author": "Priya Sharma",
    "read_time": "8 min read",
    "image": "https://images.unsplash.com/photo-1655841439659-0afc60676b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdsYXNzbW9ycGhpc20lMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3ODU5OTc3MTh8MA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-06-02T09:00:00+00:00",
    "content": "The first wave of enterprise AI was conversational: a chatbot in the corner of your website, deflecting FAQs. Useful, but shallow. The second wave — the one we are building for clients now — is agentic: systems that retrieve, reason, and act across your actual business tools.\n\nA well-designed AI agent does not just tell a customer where their order is. It checks the warehouse system, notices the delay, triggers a priority dispatch, and emails the customer an updated timeline — with a human approval step where it matters.\n\nThe enabling pattern is retrieval-augmented generation (RAG). By grounding large language models in your documents, tickets, and databases, answers become accurate, auditable, and on-brand. Hallucination stops being a risk and starts being a solved engineering problem.\n\nOur advice: start with one painful, repetitive workflow — support triage, invoice matching, lead qualification. Instrument it, automate it, measure it. Then scale. The companies winning with AI are not the ones with the biggest models; they are the ones with the cleanest data pipelines.",
    "id": "b36a4896-7f5c-4a62-94ae-5d7571281a7c"
  },
  {
    "slug": "cloud-migration-checklist-2026",
    "title": "The 2026 Cloud Migration Checklist for SMEs",
    "excerpt": "Moving to AWS, Azure, or Google Cloud is not a lift-and-shift exercise. This checklist covers cost modeling, security baselines, CI/CD, and the mistakes that inflate cloud bills.",
    "category": "Cloud & DevOps",
    "author": "Rahul Verma",
    "read_time": "7 min read",
    "image": "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdsYXNzbW9ycGhpc20lMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3ODU5OTc3MTh8MA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-05-20T09:00:00+00:00",
    "content": "Cloud migrations fail quietly. The servers move, the app runs — and six months later the bill is triple the estimate and deployments still take a day. A disciplined checklist prevents both.\n\nStart with a cost model, not a server list. Map every workload to a pricing profile: steady-state systems belong on reserved capacity, spiky workloads on autoscaling groups, and dev environments on schedules that shut them down at night.\n\nNext, the security baseline: identity-first access, encrypted storage by default, network segmentation, and audit logging from day one. Retrofitting security after migration is where budgets go to die.\n\nThen automate everything. Docker for consistent builds, Kubernetes where orchestration earns its complexity, and CI/CD pipelines that make a release a non-event. Our benchmark: any engineer should be able to ship to production in under fifteen minutes, with rollback in one click.\n\nFinally, review monthly. Cloud is not a destination; it is a meter running. The teams that treat cost as an engineering metric — alongside latency and uptime — are the ones whose migrations actually pay off.",
    "id": "6cccc19c-b8d4-4ccb-bb03-d9dd436fd72c"
  },
  {
    "slug": "cybersecurity-basics-every-business-needs",
    "title": "Cybersecurity Hygiene: The Non-Negotiables Every Business Needs in 2026",
    "excerpt": "Most breaches exploit boring gaps, not brilliant hackers. The essential controls — from access management to secure SDLC — that protect your software and your reputation.",
    "category": "Cybersecurity",
    "author": "Sneha Kulkarni",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxkYXRhJTIwYW5hbHl0aWNzJTIwY2hhcnR8ZW58MHx8fHwxNzg1OTk3NzIzfDA&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-05-06T09:00:00+00:00",
    "content": "Ask a breach investigator what went wrong and you rarely hear about zero-days. You hear about an ex-employee's active account, an unpatched plugin, a database port open to the internet. Security is mostly hygiene.\n\nThe non-negotiables: multi-factor authentication everywhere, least-privilege access reviewed quarterly, automated dependency scanning in your CI pipeline, and encrypted backups that are actually tested.\n\nFor custom software, security must live inside the development lifecycle — threat modeling during architecture, code review with a security checklist, penetration testing before launch. Bolting it on afterward costs ten times more and protects half as well.\n\nAt Serpens, every system we ship — from a school ERP to a hospital platform — carries these controls as standard. Because in 2026, security is not an IT line item. It is a promise you make to every customer who trusts you with their data.",
    "id": "b977b3ee-f245-49b4-bf6b-b93d6d5d64bd"
  },
  {
    "slug": "digital-transformation-roadmap-sme",
    "title": "A Practical Digital Transformation Roadmap for SMEs",
    "excerpt": "Digital transformation is not a buzzword — it is a sequence. Where to start, what to automate first, and how to fund each phase from the savings of the last.",
    "category": "Digital Transformation",
    "author": "Arjun Mehta",
    "read_time": "6 min read",
    "image": "https://images.unsplash.com/photo-1629904853716-f0bc54eea481?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwdGVhbSUyMHByb2dyYW1taW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NTk5NzcxOHww&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-04-22T09:00:00+00:00",
    "content": "Digital transformation fails when it is treated as a shopping spree: new CRM, new website, new app — all at once, none of it connected. It succeeds when it is treated as a sequence, where each phase funds and informs the next.\n\nPhase one is visibility. Before automating anything, instrument it: a dashboard that shows orders, inventory, cash flow, and support load in one place. You cannot improve what you cannot see.\n\nPhase two is automation of the obvious. The report someone builds every Monday. The invoice someone re-types. The approval that waits in an inbox. These are cheap wins that return hours weekly and build organizational trust in the process.\n\nPhase three is integration — connecting systems so data entered once flows everywhere. Phase four is intelligence: forecasting, recommendations, AI copilots trained on the clean data you now have.\n\nThe roadmap works because it is self-funding. The savings from phase two pay for phase three. We have walked dozens of SMEs through exactly this sequence — the only wrong move is trying to skip to the end.",
    "id": "eef2628b-9d45-4030-847d-763ecc36f3f3"
  },
  {
    "slug": "seo-for-b2b-software-companies",
    "title": "SEO for B2B: How Software Buyers Actually Search",
    "excerpt": "B2B buyers do not search like consumers. Intent mapping, technical content, and the compounding math of organic pipeline for software and IT services companies.",
    "category": "Business Growth",
    "author": "Priya Sharma",
    "read_time": "5 min read",
    "image": "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwdGVhbSUyMHByb2dyYW1taW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NTk5NzcxOHww&ixlib=rb-4.1.0&q=75&w=1200&auto=format&fit=crop",
    "published_at": "2026-04-08T09:00:00+00:00",
    "content": "A hospital administrator does not search for 'software'. She searches for 'clinic appointment scheduling with SMS reminders India'. B2B search is specific, problem-first, and ruthlessly commercial — and that is exactly why it converts.\n\nThe strategy follows the buying committee. Practitioners search for how-to content and comparisons. Managers search for ROI, case studies, and integration guides. Executives search for risk: security, compliance, vendor credibility. Your content must serve all three.\n\nTechnical foundations matter more than volume. A fast, accessible, schema-marked site with twenty deeply useful pages will outrank a bloated site with two hundred thin ones. Core Web Vitals are table stakes; original insight is the differentiator.\n\nThe compounding math is the real story. Paid ads stop the moment you stop paying. A page that ranks for a high-intent query delivers qualified pipeline every month, indefinitely. For B2B companies with long sales cycles, organic search is not a channel — it is an annuity.",
    "id": "419c2bae-52a7-4a33-8e09-ab42e763758b"
  }
];

export const MOCK_TEAM = [
  {
    "name": "Arjun Mehta",
    "role": "Founder & CEO",
    "initials": "AM",
    "bio": "15 years engineering enterprise software across three continents. Believes great software is a business strategy, not an IT expense.",
    "id": "dc7efa6a-8fb5-4eb7-a4e9-f91fa789d9a5",
    "created_at": "2026-08-06T08:05:59.572569+00:00"
  },
  {
    "name": "Priya Sharma",
    "role": "Chief Technology Officer",
    "initials": "PS",
    "bio": "Architect of 40+ platforms. Leads our AI practice and keeps our engineering bar uncompromisingly high.",
    "id": "a9ae6a81-75c9-4639-866c-8c748a61f50c",
    "created_at": "2026-08-06T08:05:59.572584+00:00"
  }
];
